// extracted by mini-css-extract-plugin
module.exports = {"link":"_1ZsO9","imageContainer":"_3pDb2","image":"zUr1F","title":"_1p4-S"};